import { B2Accordion, B2ListGroup } from "@hdb/biome-2";
import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HasPermission from "../../core/guards/has-permission";
import { useAppSelector } from "../../store/hooks";
import "./sidebar.scss";

interface SideBarComponentProps {
  moduleName: any;
  isAccordion: boolean;
}

const SideBarComponent: FC<SideBarComponentProps> = ({
  moduleName,
  isAccordion,
}) => {
  const navigate = useNavigate();
  const modules: any = useAppSelector((state) => state.navbar.modules);
  const [menuArray, setMenuArray] = useState([]);
  const [parentModule, setParentModule] = useState(null as any);
  const [activeRoute, setActiveRoute] = useState<string>("");
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(0 as any);

  const navigateToUrl = (url: any) => {
    navigate(url);
  };

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location]);

  useEffect(() => {
    if (!modules.length) return;

    const parentMenu = modules.find((m: any) => m.name === moduleName);
    const menu = modules.find((m: any) => m.name === moduleName).childMenuList;
    setParentModule(parentMenu);

    setMenuArray(
      menu.filter((menu: any) => {
        return menu?.name !== "Configuration";
      }),
    );
  }, [moduleName, modules]);

  useEffect(() => { }, [activeKey]);

  useEffect(() => {
    const activeItem = menuArray.find((menu: any) => {
      const lastSlashIndex = activeRoute?.lastIndexOf("/");
      const subString = activeRoute?.substring(0, lastSlashIndex);
      return subString.endsWith(menu.url);
    });

    if (activeItem) {
      setActiveKey(menuArray.indexOf(activeItem));
    }
  }, [activeRoute, menuArray]);

  const excludeReport = (menu: any) => {
    const excludeReportArray = ["test report", "Environmental Report"].map(
      (item) => item.toLowerCase(),
    );
    const isReport = excludeReportArray.includes(menu.name.toLowerCase());

    return isReport;
  };

  const excludeConfiguration = (menu: any) => {
    const excludeConfigurationArray = ["baseline", "alert configuration"].map(
      (item) => item.toLowerCase(),
    );
    const isConfiguration = excludeConfigurationArray.includes(
      menu.name.toLowerCase(),
    );

    return isConfiguration;
  };

  return (
    <div>
      {isAccordion ? (
        /* for admin module */
        <B2Accordion
          key={activeKey}
          defaultActiveKey={`${activeKey}`}
          onSelect={(e: any) => setActiveKey(String(e))}
        >
          {menuArray.length
            ? menuArray.map((menu: any, i: number) => (
              <HasPermission
                moduleName={menu.name}
                isRoute={false}
                actionName={`View-${menu.name}`}
                key={i + 0}
              >
                <B2Accordion.Item key={i + 0} eventKey={`${i}`}>
                  <B2Accordion.Header>{menu.name}</B2Accordion.Header>
                  <B2Accordion.Body>
                    {menu.childMenuList.map(
                      (childMenu: any, index: number) =>
                        excludeConfiguration(childMenu) ? null : (
                          <HasPermission
                            moduleName={childMenu.name}
                            isRoute={false}
                            actionName={`View-${childMenu.name}`}
                            key={index + 0}
                          >
                            <button
                              type="button"
                              className="d-flex"
                              onClick={() =>
                                navigateToUrl(
                                  `${parentModule.url}${menu.url}${childMenu.url}`,
                                )
                              }
                              style={{
                                textAlign: "left",
                                width: "100%",
                                border: "none",
                                background: "none",
                                padding: 0,
                              }}
                            >
                              <div
                                className={`p-3 flex-fill ${
                                  activeRoute.split("/")[1] ===
                                    parentModule.url.substring(1) &&
                                  activeRoute.split("/")[2] ===
                                    menu.url.substring(1) &&
                                  activeRoute.split("/")[3] ===
                                    childMenu.url.substring(1)
                                    ? "active-with-child childBg active"
                                    : ""
                                }`}
                                style={{
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                              >
                                <div className={`childmenu `} key={index + 0}>
                                  {childMenu.name}
                                </div>
                              </div>
                              {activeRoute ===
                                `${parentModule.url}${menu.url}${childMenu.url}` && (
                                  <div className="bg-primary px-1"></div>
                                )}
                            </button>
                          </HasPermission>
                        ),
                    )}
                  </B2Accordion.Body>
                </B2Accordion.Item>
              </HasPermission>
            ))
            : null}
        </B2Accordion>
      ) : (
        /* Is being used only For Report Module */

        <B2ListGroup>
          {menuArray.length
            ? menuArray.map((menu: any, i) =>
              excludeReport(menu) ? null : (
                <HasPermission
                  moduleName={menu.name}
                  isRoute={false}
                  actionName={`View-${menu.name}`}
                  key={i}
                >
                  <B2ListGroup.Item
                    active={false}
                    onClick={() =>
                      navigateToUrl(`${parentModule.url}${menu.url}`)
                    }
                    className={`cursor-pointer ${activeRoute === parentModule.url + menu.url
                      ? "active active-without-child"
                      : ""
                      }`}
                  >
                    <span style={{ color: "black" }}>{menu.name}</span>
                  </B2ListGroup.Item>
                </HasPermission>
              ),
            )
            : null}
        </B2ListGroup>
      )}
    </div>
  );
};

export default SideBarComponent;
